define([
	"dojo/_base/declare",
	"csi/def/Relationship",
	"csi/reflection",
	"csi/util"
], function(declare, Relationship, reflection, util) {

	return declare(Relationship, {
		constructor: function(def) {
			// row styling
			this.m_class = util.getProperty(def, "Class");

			// row reporting
			var t = util.getProperty(util.ssn(def, "Report"), "Type");
			var rc = t && reflection.getClass(t);
			if (rc?.enabled) {
				this.reportType = t;
			}
		}
	});
});